module.exports = __webpack_public_path__ + "static/img/fish52.995ee9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish52.png
// module id = 5eqh
// module chunks = 0